<template>
  <div>

  </div>
</template>

<script>
    export default {
      name: "MenuDash",
      data() {
        return {
          adm: false,
          permissoes: []
        }
      },
      methods: {

      },
      mounted() {
      }
    }
</script>

<style scoped>
  .row-menu{
    padding: 12px 8px!important
  }
</style>



// WEBPACK FOOTER //
// src/components/commons/MenuDash.vue